import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../payment/payment.css";
import "react-toastify/dist/ReactToastify.css";
import TextField from "@mui/material/TextField";

import ApartmentIcon from "@material-ui/icons/Apartment";
import Select from "../alerts/select";
import Red_toast from "../alerts/red_toast";
import success_toast from "../alerts/success_toast";
import Save_button from "../buttons/save_button";
import { useTranslation } from "react-i18next";

function Paymentform({
  show,
  onHide,
  user,
  route,
  callback,
  selected_branch,
  customers,
  salepersons,
  text,
  current_user,
  setloadagain,
}) {
  const { t } = useTranslation();
  const [party, setparty] = useState("");
  const [amount, setamount] = useState("");
  const [sale_person, setsale_person] = useState("");
  const [description, setdescription] = useState("");

  const [isloading, setisloading] = useState(false);
  var curr = new Date();
  var curdate = curr.toISOString().substring(0, 10);

  const [date, setdate] = useState(curdate);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selected_branch && !isloading) {
      setisloading(true);
      const formData = new FormData();

      formData.append("date", date);
      formData.append("remarks", description);
      formData.append("amount", amount);
      formData.append("reference", "CB");

      formData.append("party", party.value);
      if (text === t("side_bar_customers")) {
        formData.append("sale_person", sale_person.value);
        formData.append("credit", amount);
        formData.append("debit", 0);
        formData.append("payment_type", "credit");
      } else {
        formData.append("credit", 0);
        formData.append("debit", amount);
        formData.append("payment_type", "debit");
      }

      formData.append("branch", selected_branch.id);
      formData.append("user", current_user.id);

      const response = await fetch(`${route}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.access}`,
        },
        body: formData,
      });
      const json = await response.json();

      if (!response.ok) {
        setisloading(false);
        if (json.code === "token_not_valid") {
          callback({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }

      if (response.ok) {
        setisloading(false);
        success_toast();
        setparty("");
        setamount("");
        setdescription("");

        setdate(curdate);
        setloadagain();
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ zoom: ".8" }}
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="d-flex align-items-md-center"
        >
          <ApartmentIcon className="me-2" />
          {t("add_payment")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <Select
                options={customers}
                placeholder={text}
                value={party}
                funct={(e) => {
                  setparty(e);
                }}
                required={true}
              ></Select>

              {text === t("side_bar_customers") && (
                <Select
                  options={salepersons}
                  placeholder={t("saleman")}
                  value={sale_person}
                  funct={(e) => {
                    setsale_person(e);
                  }}
                  required={true}
                ></Select>
              )}

              {text === t("side_bar_customers") ? (
                <TextField
                  multiline
                  className="form-control   mb-3"
                  label={t("remarks")}
                  value={description}
                  onChange={(e) => setdescription(e.target.value)}
                  size="small"
                />
              ) : (
                <TextField
                  type="number"
                  className="form-control  mb-3"
                  label={t("amount")}
                  value={amount}
                  onChange={(e) => setamount(e.target.value)}
                  size="small"
                  required
                />
              )}
            </div>
            <div className="col-md-6">
              <TextField
                type="date"
                className="form-control   mb-3"
                label={t("date")}
                value={date}
                onChange={(e) => setdate(e.target.value)}
                size="small"
              />
              {text === t("side_bar_customers") ? (
                <TextField
                  type="number"
                  className="form-control  mb-3"
                  label={t("amount")}
                  value={amount}
                  onChange={(e) => setamount(e.target.value)}
                  size="small"
                  required
                />
              ) : (
                <TextField
                  multiline
                  className="form-control   mb-3"
                  label={t("remarks")}
                  value={description}
                  onChange={(e) => setdescription(e.target.value)}
                  size="small"
                />
              )}
            </div>
          </div>

          <hr></hr>
          <div className=" d-flex flex-row-reverse mt-2 me-2">
            <Save_button isloading={isloading} />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default Paymentform;
